export default {"src":"/_next/static/media/book-confidently-mobile.0ad0e9c5.svg","height":48,"width":40};